import { render, staticRenderFns } from "./AssignmentsResultsList.vue?vue&type=template&id=538d1b2a&"
import script from "./AssignmentsResultsList.vue?vue&type=script&lang=js&"
export * from "./AssignmentsResultsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports